import { useEffect, useState } from 'react';

let offset = 0;

/** Relógio do servidor: offset calculado na conexão (REQUISITOS §6.4). */
export async function syncServerTime(): Promise<void> {
  try {
    const t0 = Date.now();
    const res = await fetch('/api/v1/time');
    const t1 = Date.now();
    const { serverTime } = (await res.json()) as { serverTime: string };
    offset = new Date(serverTime).getTime() - (t0 + t1) / 2;
  } catch {
    offset = 0;
  }
}

export function serverNow(): number {
  return Date.now() + offset;
}

export function useServerNow(intervalMs = 1000): number {
  const [now, setNow] = useState(serverNow);
  useEffect(() => {
    const id = setInterval(() => setNow(serverNow()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}

/** Partida no modo por turno (single player): o que leva tempo conclui na hora; recursos entram na virada. */
export function isTurnMode(view: { config: { timeMode?: string } }): boolean {
  return view.config.timeMode === 'turn';
}

/** Duração no modo por turno: construção, pesquisa, produção e agentes concluem na hora. */
export const INSTANT = 'imediata';

/** Prazo do que ainda estiver em andamento no modo por turno (campanhas anteriores): conclui na virada. */
export const AT_TURN_END = 'na virada';
